import { Text } from "@chakra-ui/layout";
import * as React from "react";

export const Copyright = (props) => (
  <Text  {...props} color="white" fontSize="18px" fontWeight="bold">
    &copy; {new Date().getFullYear()} आनंद टेलर्स. सर्व हक्क राखीव.
  </Text>
);
